import pool from '../../../../lib/db';

export default async function handler(req, res) {
    const { slug } = req.query;

    if (req.method === 'GET') {
        try {
            const [rows] = await pool.query('SELECT * FROM blogs WHERE slug = ?', [slug]);
            
            if (rows.length === 0) {
                return res.status(404).json({ error: 'Blog post not found' });
            }

            return res.status(200).json(rows[0]);
        } catch (error) {
            console.error('Database error:', error);
            return res.status(500).json({ error: 'Internal server error' });
        }
    } else {
        res.setHeader('Allow', ['GET']);
        res.status(405).end(`Method ${req.method} Not Allowed`);
    }
}
